import { render, staticRenderFns } from "./dashboard-tags-scurve.vue?vue&type=template&id=034df2aa"
import script from "./dashboard-tags-scurve.vue?vue&type=script&lang=js"
export * from "./dashboard-tags-scurve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports